import firebase from "firebase/app";

import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import { updateDocument } from "astrid-firestore/src/helpers";

import ViewAgreementDropdownItem from "../../../../agreements/components/AgreementDropdownMenu/items/ViewAgreementDropdownItem";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function UserPriceDropdownMenu({ price, user, organization }) {
	const { t } = useTranslation();

	return (
		<DropdownMenu>
			{({ setLoading }) => (
				<>
					<ViewAgreementDropdownItem agreement={price.agreement} />

					<Dropdown.Item
						text={t("remove", "Remove")}
						onClick={async () => {
							setLoading(true);
							await updateDocument(user.ref, {
								[`prices.${organization.id}.${price.language}-${price.role}`]:
									firebase.firestore.FieldValue.delete(),
							});
							setLoading(false);
						}}
					/>
				</>
			)}
		</DropdownMenu>
	);
}
